import { apiErrorRetryAfter } from "@/lib/api";

/**
 * How long a throttled request (a 429) asks the user to wait, from its
 * `Retry-After` header, rounded up to whole minutes: "1 minute", "15 minutes".
 * `undefined` when the answer named no wait, so the caller words it loosely.
 */
export function retryAfterLabel(error: unknown): string | undefined {
  const seconds = apiErrorRetryAfter(error);
  if (seconds === undefined || seconds <= 0) {
    return undefined;
  }
  const minutes = Math.ceil(seconds / 60);
  return minutes === 1 ? "1 minute" : `${minutes} minutes`;
}
